<template>
    <div class="team-preview">
      <router-link
        class="team-preview__link"
        :to="{
          name: 'TeamPage',
          params: {
            link: teamData.link,
          },
        }"
      >
        <div class="team-preview__image">
          <el-avatar :size="50">
            <activity-image :activity="teamData.activityId" />
          </el-avatar>
        </div>
  
        <div class="team-preview__content">
          <div class="team-preview__heading">
            <div class="team-preview__title" v-if="teamData.name">
              {{ teamData.name }}
            </div>
  
            <span class="team-preview__date" v-if="teamData.startDate">
              {{ formatDate(teamData.startDate, SHORT_DATETIME_FORMAT) }}
            </span>
          </div>
  
          <div class="team-preview__description" v-if="teamData.details">
            {{ teamData.details }}
          </div>
  
          <div class="team-preview__location" v-if="teamData.location">
            <i class="el-icon-location-outline"></i>
            {{ teamData.location }}
          </div>
        </div>
      </router-link>
  
      <div class="team-preview__button" v-if="isActive">
        <el-button
          :type="buttonType || 'primary'"
          @click.stop="handleClickButton"
        >
          {{ buttonLabel || 'Join' }}
        </el-button>
      </div>
    </div>
  </template>
  
  <script>
  import ActivityImage from '@/components/common/ActivityImage.vue';
  import { formatDate, SHORT_DATETIME_FORMAT } from '@/utils/index.js';
  
  export default {
    name: 'TeamPreview',
    props: {
      teamData: {
        type: Object,
        required: true,
      },
      buttonType: {
        type: String,
        required: false,
      },
      buttonLabel: {
        type: String,
        required: false,
      },
      buttonAction: {
        type: Function,
        required: false,
      },
      isActive: {
        type: Boolean,
        required: false,
      },
    },
    components: {
      ActivityImage
    },
    data() {
      return {
        SHORT_DATETIME_FORMAT,
      };
    },
    methods: {
      formatDate,
      handleClickButton() {
        const { buttonAction, teamData } = this;
  
        if (buttonAction) {
          buttonAction(teamData);
        }
      },
    },
  };
  </script>
  
  <style scoped>
    .team-preview__link {
      display: flex;
      align-items: center;
      gap: 12px;
      text-decoration: none;
    }

    .team-preview__name {
      font-weight: 600;
    }

    .team-preview__description {
      color: var(--el-text-color-secondary);
      font-size: 13px;
    }
  </style>
  